import { DEVELOPMENT_URL, PRODUCTION_URL } from '../config';

/**
 * Vratime url endpoint.
 *
 * @return {string}
 */
export const getUrl = () => (process.env.NODE_ENV && process.env.NODE_ENV === 'production' ? PRODUCTION_URL : DEVELOPMENT_URL);
